import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { IAnchorProps } from "../../interfaces";
import {debounce} from "utils-decorators";
import * as _ from "lodash";

@Component({
    selector: 'app-constraint-checker',
    templateUrl: './constraint-checker.component.html',
    styleUrls: ['./constraint-checker.component.scss']
})
export class ConstraintCheckerComponent {

    model: IAnchorProps;

    @Input()
    set setModel(i_model: IAnchorProps) {
        this.model = i_model;
        this.cd.markForCheck();
    }

    @Output() changed = new EventEmitter<any>();

    constructor(private cd: ChangeDetectorRef) {
    }

    // @debounce(33)
    onChange(i_from) {
        this.changed.emit(i_from);
    }
}
